import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import { toggleCollapseLock } from '../../../lib/redux/navBarCollapse/navBarCollapseSlice';

const ToggleNavBar = () => {
  const { locked } = useSelector(state => state.navBarCollapse);
  const dispatch = useDispatch();

  return (
    <Wrapper
      onClick={() => {
        dispatch(toggleCollapseLock());
        localStorage.setItem('lockNavBar', !locked);
      }}
      data-cy="toggleNavBar"
    >
      <MenuIcon
        showIcon={locked}
        className="fa-solid fa-ellipsis-vertical fa-xl"
      />
      <MenuIcon showIcon={!locked} className="fa-solid fa-list-ul fa-xl" />
    </Wrapper>
  );
};

export default ToggleNavBar;

const Wrapper = styled.div`
  display: none;

  ${themeGet('mediaQueries.forMediumUp')} {
    display: block;
    width: 65px;
    height: 70px;
    border-right: 1px solid ${themeGet('colors.black.10')};
    border-bottom: 1px solid ${themeGet('colors.black.10')};
    cursor: pointer;
    position: relative;

    &:hover {
      background: ${themeGet('colors.black.10')};
    }
  }
`;

const MenuIcon = styled.i`
  position: absolute;
  transition: opacity 1s ease-in-out;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: ${({ showIcon }) => (showIcon ? '100%' : '0')};
`;
